import * as React from 'react';
// import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';
import { VoucherApi } from 'common/api/resources/Voucher';
import { Loading } from '../Loading';

interface VoucherCancelDialogProps {
  isOpen: boolean;
  voucher: any;
  onSave: () => void;
  onCancel: () => void;
  title?: string;
}
class FormValues {
  description: string;
}
export interface VoucherCancelDialogState {
  error?: string;
  isLoading: boolean;
}
export class VoucherCancelDialog extends React.Component<VoucherCancelDialogProps, VoucherCancelDialogState> {
  state: VoucherCancelDialogState = {
    error: '',
    isLoading: false,
  };
  initialValues() {
    return {
      description:
        this.props.voucher && this.props.voucher.cancelledReasonNote ? this.props.voucher.cancelledReasonNote : '',
    };
  }

  handleSubmit = async (values: FormValues) => {
    // console.log(activatedDate);
    await this.setState({ isLoading: true });
    if (this.props.voucher) {
      const updateVoucher = {
        cancelledReason: 'CANCELLED_MANUALLY',
        cancelledReasonNote: values.description,
        isCanceled: true,
      };
      VoucherApi.updateVoucher(this.props.voucher.id, updateVoucher)
        .then(() => {
          this.setState({ isLoading: false });
          this.props.onSave();
        })
        .catch(e => {
          console.error(e);
          this.setState({ isLoading: false });
        });
    }
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<FormValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>{this.props.title ? this.props.title : ''}</ModalHeader>
              <ModalBody>
                {/* <label>Cancel Reason Notes</label> */}
                <FormInput
                  tag="textarea"
                  id="description"
                  name="description"
                  label="Cancel Reason Notes"
                  autoComplete="off"
                />
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel} disabled={this.state.isLoading}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit" disabled={this.state.isLoading}>
                    Save
                  </Button>
                </div>
              </ModalFooter>
              {this.state!.isLoading && (
                <div style={{ margin: 10 }}>
                  <Loading message="Saving..." />
                </div>
              )}
              {this.state!.error && <div className="alert alert-danger">{this.state!.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/VoucherCancelDialog.tsx